import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import SearchBar from '../../components/SearchBar/SearchBar';
import Reload from '../../components/reload/reload';
import Headers from '../../components/Headers/Headers';
import Page from '../../components/Page/Page';
import ModernTable from '../../components/ModernTable/ModernTable';
import { useNavigate } from 'react-router-dom';
import decodeJwt from '../../hooks/decode';

const Dryer = () => {
  const navigate = useNavigate();
 
  const userDecoded = decodeJwt();
  const { permissionSGU } = userDecoded;
  if (permissionSGU?.dryer?.read !== true) {
    navigate("/home");
  }

  const [data] = useState(() => {
    try {
      const cooperatives = JSON.parse(localStorage.getItem('units')) ||
        [JSON.parse(localStorage.getItem('cooperative'))] ||
        [];

      // Extrai todos os secadores de todas as cooperativas
      const allDryers = [];
      cooperatives.forEach(cooperative => {
        if (cooperative?.dryer && Array.isArray(cooperative.dryer)) {
          cooperative.dryer.forEach(dryer => {
            allDryers.push({
              ...dryer,
              cooperativeName: cooperative.name,
              cooperativeId: cooperative._id
            });
          });
        }
      });

      return allDryers;
    } catch (error) {
      console.error('Error parsing dryer data:', error);
      return [];
    }
  });

  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState(data);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleSearchData = useCallback((value) => {
    const searchValue = value.toUpperCase();
    const filtered = data.filter(item =>
      (item?.nome?.toUpperCase().includes(searchValue)) ||
      (item?.localizacao?.toUpperCase().includes(searchValue)) ||
      (item?.cooperativeName?.toUpperCase().includes(searchValue)) ||
      (item?.equipamentos?.some(eq => eq.toUpperCase().includes(searchValue)))
    );
    setFilteredData(filtered);
    setPage(0);
  }, [data]);

  const totalPages = useMemo(() => Math.ceil(filteredData.length / rowsPerPage), [filteredData.length, rowsPerPage]);
  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0); // Reset to first page when changing rows per page
  }, []);

  const getPaginationRange = useCallback(() => {
    const start = Math.max(page - 2, 0);
    const end = Math.min(page + 2, totalPages - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }, [page, totalPages]);

  const handlePage = useCallback((link) => {
    navigate(link);
  }, [navigate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  const columns = ["NOME", "LOCALIZAÇÃO", "EMPRESA", "EQUIPAMENTOS", "ID", "AÇÕES"];

  // Função para renderizar os botões de ação
  const renderActions = (item, index) => (

    <div className="d-flex justify-content-center gap-2">
      <Button
        size="sm"
        variant="outline-success"
        className="px-3"
        onClick={() => handlePage(`/dryer/detail/${item[5]}`)}
        disabled={!item[5]}
        style={{
          borderRadius: '8px',
          transition: 'all 0.2s ease'
        }}
      >
        <i className="fas fa-eye me-1"></i>
        Visualizar
      </Button>
    </div>
  );

  // Configuração da paginação para ModernTable
  const paginationConfig = {
    currentPage: page,
    totalPages: totalPages,
    rowsPerPage: rowsPerPage,
    total: filteredData.length,
    currentStart: page * rowsPerPage,
    currentEnd: (page + 1) * rowsPerPage,
    pageNumbers: getPaginationRange(),
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  };

  return (
    <Page title="Secadores">
      <Headers page="Secadores" />

      {loading && <Reload />}

      <SearchBar onSearch={handleSearchData} />

      <Card className="border-0 shadow-sm mt-2">

        <Card.Header className="bg-white border-0 py-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0 fw-semibold text-white">Lista de Secadores</h5>
              <small className="text-white">
                Mostrando {paginatedData.length} de {filteredData.length} secadores
              </small>
            </div>
            <Badge bg="light" text="dark" className="px-3 py-2">
              <i className="fas fa-list me-2"></i>
              {filteredData.length} registros
            </Badge>
          </div>
        </Card.Header>

        <Card.Body className="p-0">
          <ModernTable
            columns={columns}
            data={paginatedData.map((item) => ([
              item.nome,
              item.localizacao,
              userDecoded?.hideSensitiveInfo ? '***' : item.cooperativeName,
              item.equipamentos?.length || 0,
              item._id,
              item._id
            ]))}
            actions={renderActions}
            pagination={paginationConfig}
          />
        </Card.Body>
      </Card>
    </Page>
  );
};

export default Dryer;
